import { formatRelativeDate } from '@bpinternal/shared'
import { useActiveTrial } from '~/features/billing/hooks/useFreeTrial'

export const NavFreeTrial = ({ workspaceId }: { workspaceId: string }) => {
  const activeTrial = useActiveTrial(workspaceId)
  if (!activeTrial) return null

  const endsAt = formatRelativeDate(activeTrial.endsAt.toString())

  return <p className="pr-5 text-sm font-medium text-muted-foreground">Your trial ends {endsAt}</p>
}
